// Builtin Imports
import React, { useEffect, useState } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';

// Internal Imports
import './App.css';
import AppCtx from './context/AppCtx';
import Web3Manager from './components/Web3Manager/Web3Manager';
import Header from './components/Header/Header';
import routes from './Routes';
import BackgroundImg from './components/common/BackgroundImg';

// Third Party Imports
import { ToastContainer } from 'react-toast';
import { Box, createTheme, ThemeProvider } from '@mui/material';
import useWeb3Ctx from './hooks/useWeb3Ctx';
import useAppCtx from './hooks/useAppCtx';

const BP1 = '@media (max-width: 539px)';
const BP2 = '@media (max-width: 999px)';
const BP3 = '@media (max-width: 1480px) and (min-width:1199px)';

const sx = {
  root: {
    position: 'relative',
    minHeight: '100%',
  },
  pageRoot: {
    width: '100%',
    transition: 'all .3s',
    // position: 'relative',
  },
  content: {
    width: '100%',
    minHeight: 'calc(100vh - 138px)',
    mx: 'auto',
    // pt: '40px',
    transition: 'all .3s',
    px: '56px',
  },
};

const COLORS = {
  dark: '#000',
  white: '#FFF',
  error: '#FF1414',
};

const theme = createTheme({
  typography: {
    fontFamily: 'poppins',
    fontSize: '16px',
    allVariants: {
      color: COLORS.white,
    },
    heading1: {
      fontFamily: 'poppins',
      fontWeight: '900',
      fontSize: '32px',
      lineHeight: '42px',
      transition: 'all .3s',
      [BP1]: {
        fontSize: '24px',
      },
    },
    heading2: {
      fontFamily: 'poppins',
      fontWeight: '900',
      fontSize: '26px',
      lineHeight: '34px',
    },
    title: {
      fontFamily: 'Overpass',
      fontWeight: '900',
      fontSize: '3rem',
      lineHeight: '2.4rem',
    },
    body1: {
      fontFamily: 'poppins',
      fontSize: '16px',
      lineHeight: '29px',
      color: '#000003',
    },
    h6: {
      fontSize: '18px',
      fontWeight: '800',
    },
  },
  palette: {
    primary: {
      main: COLORS.white,
    },
    text: {
      primary: COLORS.white,
    },
    blue: {
      main: '#5deffb',
    },
    error: {
      main: COLORS.error,
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          body1: 'div',
          heading1: 'p',
          heading2: 'p',
          text: 'p',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '16px',
          padding: '16px',
          backgroundColor: '#9A989A',
          color: '#000207',
          boxShadow: '0px 0px 30px #FFFFFF33',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          borderRadius: '8px',
          '&.Mui-disabled': {
            backgroundColor: '#BE1FDA',
            color: '#FFF',
            opacity: 0.4,
          },
        },
        outlined: {
          minHeight: '40px',
          fontSize: '0.8rem',
          fontWeight: '500',
          borderRadius: '8px',
          borderWidth: '2px',
          '&:hover': {
            border: '2px solid #FFF;',
          },
          '&.Mui-disabled': {
            color: '#FFF',
            opacity: 0.4,
          },
        },
        text: {
          '&.Mui-disabled': {
            color: '#BE1FDA',
            opacity: 0.4,
          },
        },
        root: {
          '&:focus': {
            outline: 'none',
          },
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            opacity: 0.5,
          },
        },
      },
    },
  },
});

const Updater = () => {
  const { address } = useWeb3Ctx();
  const { setMetadata, setMetadataLoaded } = useAppCtx();

  useEffect(() => {
    if (!address) {
      setMetadata([])
      setMetadataLoaded(false)
    }
  }, [address])

  return null
}

function App() {
  const [txInProgress, setTxInProgress] = useState(false);
  const [txEtherScan, setTxEtherScan] = useState(false);
  const [metadata, setMetadata] = useState([]);
  const [metadataLoaded, setMetadataLoaded] = useState(false);
  const [loading, setLoading] = useState(false);

  // console.log(theme);

  return (
    <Web3Manager>
      <AppCtx.Provider
        value={{ txInProgress, setTxInProgress, txEtherScan, setTxEtherScan, metadata, setMetadata, metadataLoaded, setMetadataLoaded, loading, setLoading }}
      >
        <Updater />
        <ThemeProvider theme={theme}>
          <Box sx={sx.root}>
            <HashRouter basename="/">
              {/* <Box
                sx={{
                  ...sx.pageRoot,
                  background: txPending && 'rgb(81, 87, 255)',
                }}
              >
                <Box sx={sx.content}> */}
              <Switch>
                {routes.map((route, key) => (
                  <Route
                    key={key.toString()}
                    path={route.path}
                    component={route.component}
                    exact={route.exact}
                  />
                ))}
              </Switch>
              <ToastContainer delay={4000} position="bottom-right" />
              {/* </Box>
              </Box> */}
            </HashRouter>
          </Box>
        </ThemeProvider>
      </AppCtx.Provider>
    </Web3Manager>
  );
}

export default App;
